import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abbreviate',
})
export class AbbreviatePipe implements PipeTransform {
  transform(value: string, maxLength: number = 50): string {
    return value.length > maxLength
      ? value.substring(0, maxLength / 2) +
          '...' +
          value.substring(value.length - maxLength / 2, value.length)
      : value;
  }
}
